import { render, staticRenderFns } from "./commonNav.vue?vue&type=template&id=085fa15a&"
import script from "./commonNav.vue?vue&type=script&lang=ts&"
export * from "./commonNav.vue?vue&type=script&lang=ts&"
import style0 from "./commonNav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports